export const AUTH_CODE = 'authCode';
export const MFA_AUTH_TOKEN = 'mfa_auth_token';
export const MFA_COOKIE = 'mfa_cookie';
export const REDIRECT_APP = 'redirect_app';
export const REDIRECT_PATH = 'redirect_path';
export const EMAIL = 'email';
export const CO_BRANDING = 'co_branding';
